import { render } from "./Headernav.vue?vue&type=template&id=49887d64&scoped=true"
import script from "./Headernav.vue?vue&type=script&lang=js"
export * from "./Headernav.vue?vue&type=script&lang=js"

import "./headernav.scss?vue&type=style&index=0&id=49887d64&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49887d64"]])

export default __exports__